<script>
export default {};
</script>
<template>
  <!-- section -->
  <footer class="py-5" style="background-color: #eee">
    <ul class="d-flex justify-content-center list-unstyled">
      <li class="me-4">關於我們</li>
      <li class="me-4">關於我們</li>
      <li class="me-4">關於我們</li>
      <li class="me-4">關於我們</li>
    </ul>

    <ul class="d-flex justify-content-center list-unstyled">
      <li class="me-4">
        <a href="">
          <svg
            class="fill-current gray"
            width="24px"
            viewBox="0 0 512.001 512.001"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M373.406 0H138.594C62.172 0 0 62.172 0 138.594V373.41C0 449.828 62.172 512 138.594 512H373.41C449.828 512 512 449.828 512 373.41V138.594C512 62.172 449.828 0 373.406 0zm108.578 373.41c0 59.867-48.707 108.574-108.578 108.574H138.594c-59.871 0-108.578-48.707-108.578-108.574V138.594c0-59.871 48.707-108.578 108.578-108.578H373.41c59.867 0 108.574 48.707 108.574 108.578zm0 0"
            />
            <path
              d="M256 116.004c-77.195 0-139.996 62.8-139.996 139.996S178.804 395.996 256 395.996 395.996 333.196 395.996 256 333.196 116.004 256 116.004zm0 249.976c-60.64 0-109.98-49.335-109.98-109.98 0-60.64 49.34-109.98 109.98-109.98 60.645 0 109.98 49.34 109.98 109.98 0 60.645-49.335 109.98-109.98 109.98zm0 0M399.344 66.285c-22.813 0-41.367 18.559-41.367 41.367 0 22.813 18.554 41.371 41.367 41.371s41.37-18.558 41.37-41.37-18.558-41.368-41.37-41.368zm0 52.719c-6.258 0-11.352-5.094-11.352-11.352 0-6.261 5.094-11.351 11.352-11.351 6.261 0 11.355 5.09 11.355 11.351 0 6.258-5.094 11.352-11.355 11.352zm0 0"
            />
          </svg>
        </a>
      </li>
      <li class="me-4">
        <a href="">
          <svg
            class="fill-current gray"
            viewBox="0 0 512 512"
            width="24px"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M489.41 21.848C475 7.758 456.031 0 436 0H75C33.645 0 0 33.645 0 75v362c0 41.355 33.645 75 75 75h362c41.355 0 75-33.645 75-75V75c0-20.04-8.023-38.914-22.59-53.152zM271 271h-30v-30h30c8.285 0 15-6.715 15-15 0-41.14-.004-59.957-.004-68.613-.004-15.934.02-33.29 15.582-46.606 11.863-10.148 26.985-16.277 47.594-19.293 21.742-3.175 43.808-2.183 67.113 3.047-1.77 11.91-3.867 26.02-5.45 36.653-8.843-1.793-24.019-3.243-36.44-1.137C346.816 134.715 331 151.828 331 177v49c0 8.285 6.715 15 15 15h55.79l-7.5 30H346c-8.285 0-15 6.715-15 15v196h-45V286c0-8.285-6.715-15-15-15zm211 166c0 24.813-20.188 45-45 45h-76V301h45a14.996 14.996 0 0014.55-11.363l15-60a15.001 15.001 0 00-2.726-12.867A15.008 15.008 0 00421 211h-60v-34c0-6.898 1.422-14.5 18.406-17.375 13.29-2.25 25.164.719 35.64 3.344 5.036 1.258 10.454 3.176 16.63-1.004a15.018 15.018 0 006.43-10.211s6.738-45.27 9.843-66.2a15.001 15.001 0 00-10.734-16.632c-29.297-8.332-65.133-11.07-92.184-7.117-26.46 3.87-46.601 12.187-62.957 26.183-22.754 19.469-25.578 44.45-25.87 61.485-.009.347-.005 30.648-.005 61.527H226c-8.285 0-15 6.715-15 15v60c0 8.285 6.715 15 15 15h30v181H75c-24.813 0-45-20.188-45-45V75c0-24.813 20.188-45 45-45h361c24.934 0 46 20.61 46 45zm0 0"
            />
          </svg>
        </a>
      </li>
      <li class="me-4">
        <a href="">
          <svg
            class="fill-current gray"
            width="24px"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 52.851 52.851"
          >
            <path
              d="M52.412 9.656a1.002 1.002 0 00-1.165.031c-.449.34-1.179.61-1.965.818 2.047-2.294 2.091-3.826 2.069-4.178a1 1 0 00-1.586-.746c-2.303 1.674-4.597 2.027-5.961 2.063a11.067 11.067 0 00-7.707-3.102c-6.196 0-11.236 5.108-11.236 11.386 0 .54.038 1.079.113 1.613C14.236 17.42 5.516 7.131 5.426 7.024a1 1 0 00-1.634.142c-3.09 5.36-1.022 10.068.868 12.764a6.617 6.617 0 01-.767-.473 1 1 0 00-1.598.786c-.083 5.108 2.375 8.034 4.687 9.652a1 1 0 00-1.056 1.287c1.597 5.227 5.518 7.003 8.013 7.606-5.13 3.994-12.68 2.708-12.763 2.694a1 1 0 00-.783 1.779c5.415 4.133 11.892 5.048 16.57 5.048 3.539 0 6.05-.524 6.29-.577 23.698-5.616 24.365-27.323 24.31-30.88 4.449-4.137 5.144-5.713 5.251-6.103a.997.997 0 00-.402-1.093zm-6.538 6.035a1 1 0 00-.32.803c.063.96 1.275 23.597-22.742 29.288-.109.023-9.656 2.015-17.932-2.085 3.497-.097 8.511-1.013 12.004-4.935a.998.998 0 00-.746-1.665h-.01c-.05.032-5.301-.006-7.705-5.001.968.055 2.162-.005 3.113-.443a1 1 0 00-.213-1.887c-.269-.057-6.115-1.364-6.933-7.741.887.388 2.022.705 3.144.534a.999.999 0 00.506-1.745c-.25-.218-5.74-5.097-3.137-11.39 2.826 2.965 11.196 10.67 21.337 10.088a1.004 1.004 0 00.913-1.242 9.628 9.628 0 01-.29-2.341c0-5.176 4.144-9.386 9.237-9.386 2.491 0 4.828.994 6.579 2.8.184.19.437.299.701.304 1.06.015 2.802-.11 4.77-.899-.568.707-1.402 1.554-2.629 2.518a1 1 0 00.698 1.783 22.6 22.6 0 002.764-.414 56.969 56.969 0 01-3.109 3.056z"
            />
          </svg>
        </a>
      </li>
      <li>
        <a href="https://www.youtube.com/">
          <svg
            class="fill-currnet gray"
            width="24px"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 49 49"
          >
            <path
              d="M39.256 6.5H9.744C4.371 6.5 0 10.885 0 16.274v16.451c0 5.39 4.371 9.774 9.744 9.774h29.512c5.373 0 9.744-4.385 9.744-9.774V16.274c0-5.389-4.371-9.774-9.744-9.774zM47 32.726c0 4.287-3.474 7.774-7.744 7.774H9.744C5.474 40.5 2 37.012 2 32.726V16.274C2 11.988 5.474 8.5 9.744 8.5h29.512c4.27 0 7.744 3.488 7.744 7.774v16.452z"
            />
            <path
              d="M33.36 24.138l-13.855-8.115a1.002 1.002 0 00-1.505.863v16.229a1.002 1.002 0 001 1 1 1 0 00.505-.137l13.855-8.113a1 1 0 000-1.727zM20 31.37V18.63l10.876 6.371L20 31.37z"
            />
          </svg>
        </a>
      </li>
    </ul>
  </footer>
</template>

<style lang="scss" scoped>
footer {
}
</style>
